import { useState, useRef } from "react";

export default function UploadZone({ onFiles, uploading = false }) {
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files?.length) {
      onFiles(Array.from(e.dataTransfer.files));
    }
  };

  const handleChange = (e) => {
    if (e.target.files?.length) {
      onFiles(Array.from(e.target.files));
      e.target.value = "";
    }
  };

  return (
    <div
      className={`border-2 border-dashed rounded-xl p-6 text-center transition-all cursor-pointer ${
        dragActive
          ? "border-carex-400 bg-carex-50"
          : "border-slate-300 hover:border-slate-400 bg-slate-50/50"
      } ${uploading ? "opacity-50 pointer-events-none" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept="image/jpeg,image/png,image/webp"
        multiple
        onChange={handleChange}
      />
      <svg
        className="w-10 h-10 mx-auto text-slate-400 mb-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
        />
      </svg>
      <p className="text-sm font-medium text-slate-600">
        {uploading ? "Upload en cours..." : "Ajouter des photos"}
      </p>
      <p className="text-xs text-slate-400 mt-1">
        Glissez-déposez ou cliquez pour sélectionner (JPEG, PNG, WebP)
      </p>
    </div>
  );
}
